import React from 'react'
import { useTranslation } from 'react-i18next'

export const BackBtn = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36" fill="none">
    <mask id="mask0_52_4019" style={{ "maskType": "alpha" }} maskUnits="userSpaceOnUse" x="4" y="6" width="28"
      height="24">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M16.8104 8.93566C17.3962 8.34987 17.3962 7.40013 16.8104 6.81434C16.2246 6.22855 15.2749 6.22855 14.6891 6.81434L4.6348 16.8686C4.62211 16.8813 4.60968 16.8942 4.5975 16.9072C4.30663 17.1808 4.125 17.5692 4.125 18C4.125 18.4308 4.30664 18.8192 4.59751 19.0928C4.60968 19.1058 4.62211 19.1187 4.6348 19.1314L14.6891 29.1857C15.2749 29.7714 16.2246 29.7714 16.8104 29.1857C17.3962 28.5999 17.3962 27.6501 16.8104 27.0643L9.24607 19.5H30.375C31.2034 19.5 31.875 18.8284 31.875 18C31.875 17.1716 31.2034 16.5 30.375 16.5H9.24607L16.8104 8.93566Z"
        fill="black" />
    </mask>
    <g mask="url(#mask0_52_4019)">
      <rect width="36" height="36" fill="#808080" />
    </g>
  </svg>
}

export const SubjectName = () => {
  const { t } = useTranslation()
  return <span className={'linkSpan'} data-fade>{t('goBack')}
  </span>
}

export const SubjectNameGender = () => {
  const { t } = useTranslation()
  return <span className={'linkSpan afade'} data-fade>{t('goBack')}</span>
}
